import React from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Paper 
          elevation={3} 
          sx={{ 
            p: { xs: 4, md: 6 }, 
            textAlign: 'center', 
            borderRadius: 3,
            bgcolor: 'background.paper'
          }}
        >
          <Box 
            component="img"
            src="/eagle-logo-transparent.png"
            alt="Eagles Refuge Academy Logo"
            sx={{
              height: 100,
              mb: 3
            }}
          />

          <Typography variant="h3" sx={{ fontWeight: 600, mb: 2, color: 'primary.main' }}>
            Oops...
          </Typography>
          
          <Typography variant="h5" sx={{ mb: 4, color: 'text.secondary' }}>
            This is embarrassing, the page you are looking for is missing.
          </Typography>

          
          <Button 
            component={Link} 
            to="/" 
            variant="contained" 
            size="large"
            sx={{ 
              px: 4, 
              py: 1.5,
              fontSize: '1.1rem'
            }}
          >
            Return to Homepage
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default NotFound;